// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistant_errors_processingerrors_unknown2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unknown error occurred while processing the case:`)
};

const en_us2_assistant_errors_processingerrors_unknown2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unknown error occurred while processing the case:`)
};

const de_de2_assistant_errors_processingerrors_unknown2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Verarbeiten des Vorgangs ist ein unbekannter Fehler aufgetreten:`)
};

const en_assistant_errors_processingerrors_unknown2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unknown error occurred while processing the case:`)
};

const de_assistant_errors_processingerrors_unknown2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Verarbeiten des Vorgangs ist ein unbekannter Fehler aufgetreten:`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistant_errors_processingerrors_unknown2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistant_errors_processingerrors_unknown2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistant_errors_processingerrors_unknown2", locale)
	if (locale === "en-GB") return en_gb2_assistant_errors_processingerrors_unknown2(inputs)
	if (locale === "en-US") return en_us2_assistant_errors_processingerrors_unknown2(inputs)
	if (locale === "de-DE") return de_de2_assistant_errors_processingerrors_unknown2(inputs)
	if (locale === "en") return en_assistant_errors_processingerrors_unknown2(inputs)
	return de_assistant_errors_processingerrors_unknown2(inputs)
};
export { assistant_errors_processingerrors_unknown2 as "assistant.errors.processingErrors.Unknown" }